import React from "react";
import MyTitle from "../myTitle";
import Btn from "../btn";
import styleObj from "./style.module.scss";
import Product2021 from "./2021";

export default function Product(props) {
  let { productAddress, meta } = props;
  return (
    <>
      {meta?.is2021 ? (
        <Product2021 {...props} />
      ) : (
        <div className={styleObj["product-wrap"]}>
          <MyTitle mainTitle="产品展示" subTitle="SHOW" />
          <div className={styleObj["content"]}>
            <div className={styleObj["left"]}>
              <img
                src={require(`../../assets/imgs/experience-intro.png`)}
                alt=""
              />
              <Btn href={productAddress} text="立即购买" />
            </div>
            <div className={styleObj["right"]}>
              <img
                src={require(`../../assets/imgs/experience-tv.png`)}
                alt=""
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
}
